import { useCompare } from "@/lib/compare";
import { Pin, PinOff } from "lucide-react";
import { toast } from "sonner";

export default function CompareToggle({ slug, title, variant = "card" }) {  const { toggle, isPinned, slugs } = useCompare();
  const pinned = isPinned(slug);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const result = toggle(slug);
    if (result === "added") {
      toast.success(slugs.length === 0 ? `${title} pinned — pin one more to compare` : `${title} pinned — open Compare to see them side by side`);
    }
    if (result === "swapped") toast.success(`${title} pinned — replaced your earliest pick`);
  };

  if (variant === "detail") {
    return (
      <button
        data-testid={`compare-toggle-${slug}`}
        onClick={onClick}
        className={`mt-3 w-full btn-pill justify-center text-sm ${pinned ? "bg-[#1F150E] text-[#FAF6F0]" : "btn-pill-outline"}`}
      >
        {pinned ? <><PinOff size={14} /> Remove from comparison</> : <><Pin size={14} /> Pin to compare</>}
      </button>
    );
  }

  return (
    <button
      data-testid={`compare-toggle-${slug}`}
      onClick={onClick}
      title={pinned ? "Remove from comparison" : "Pin to compare"}
      aria-label={pinned ? `Remove ${title} from comparison` : `Pin ${title} to compare`}
      className={`absolute top-4 right-4 w-10 h-10 rounded-full flex items-center justify-center backdrop-blur transition-all duration-300 ${
        pinned
          ? "bg-[#1F150E] text-[#FAF6F0] scale-105"
          : "bg-[#FAF6F0]/90 text-[#23170E]/70 hover:bg-[#23170E] hover:text-[#FAF6F0]"
      }`}
    >
      <Pin size={15} fill={pinned ? "currentColor" : "none"} />
    </button>
  );
}
